 // Build-time override, e.g. REACT_APP_HOST_API=https://staging.aslaa.mn/ npm run build
export const HOST_API = process.env.REACT_APP_HOST_API || "https://www.aslaa.mn/";
// export const HOST_API = "http://localhost:5000/";